<div class="sidebar">

    <ul class="sidebar-menu">

        <li routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <i class="pi pi-home"></i> Home
        </li>

        <li routerLink="/projects" routerLinkActive="active">
            <i class="pi pi-folder"></i> Projects
        </li>
        <li routerLink="/microservices" routerLinkActive="active">
            <i class="pi pi-folder"></i> Microservices
        </li>

        <li class="menu-group" *ngIf="showAgentsGroup">
            <i class="fa-solid fa-wand-magic-sparkles"></i> AI Agents
        </li>

        <li *ngIf="perms.has(P.agentList)" class="sub" routerLink="/ai-agents/agents" routerLinkActive="active">
            <i class="fa-solid fa-robot"></i> Agents
        </li>

        <li *ngIf="perms.has(P.conversationList)" class="sub" routerLink="/ai-agents/conversations" routerLinkActive="active">
            <i class="fa-solid fa-comments"></i> Conversations
        </li>

        <li *ngIf="perms.has(P.providerList)" class="sub" routerLink="/ai-agents/providers" routerLinkActive="active">
            <i class="fa-solid fa-plug"></i> LLM Providers
        </li>

        <li *ngIf="perms.has(P.modelList)" class="sub" routerLink="/ai-agents/models" routerLinkActive="active">
            <i class="fa-solid fa-microchip"></i> LLM Models
        </li>

        <li *ngIf="perms.has(P.capabilityList)" class="sub" routerLink="/ai-agents/capability-models" routerLinkActive="active">
            <i class="fa-solid fa-wave-square"></i> Capability models
        </li>

        <li *ngIf="perms.has(P.planList)" class="sub" routerLink="/ai-agents/project-plans" routerLinkActive="active">
            <i class="fa-solid fa-sliders"></i> Project plans
        </li>


        <li routerLink="/users" routerLinkActive="active">
            <i class="pi pi-users"></i> Users
        </li>

        <li routerLink="/roles" routerLinkActive="active">
            <i class="pi pi-lock"></i> Roles
        </li>

    </ul>

</div>
